import { useQuery } from '@tanstack/react-query';
import { getFinanceLookups } from '../../api/finance';

/** Filter/dropdown values for the Finance pages (cached for the session). */
export const useFinanceLookups = () =>
  useQuery({ queryKey: ['finance-lookups'], queryFn: getFinanceLookups, staleTime: 5 * 60_000 });
